// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ContatosFidelizacao_SaveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /contatos_fidelizacao/save
 */
import { registerContract } from './validate'

export interface ContatosFidelizacao_SaveInput {
contatofidelizacao_franquia_id: number
contatofidelizacao_cliente_id: number
contatofidelizacao_content: string
contatofidelizacao_data_cadastro?: string
contatofidelizacao_owner?: string
contatofidelizacao_owner_id?: string
}

registerContract('ContatosFidelizacao_SaveInput', {
  contatofidelizacao_franquia_id:   { type: 'number',  required: true },
  contatofidelizacao_cliente_id:    { type: 'number',  required: true },
  contatofidelizacao_content:       { type: 'string',  required: true },
  contatofidelizacao_data_cadastro: { type: 'string',  required: false },
  contatofidelizacao_owner:         { type: 'string',  required: false },
  contatofidelizacao_owner_id:      { type: 'string',  required: false },
})
